/**
 * @Author：zsj
 * @Date：2022/03/09
 */
import request from "../request";

export const getHomeInfo = params => request.get('/get', params, {
    useMock: true,
    resInterceptor: (res) => {
        console.log('resInterceptor 执行')
        return res
    },
    // showLoading: true,
    // showLoading: () => {
    //     console.log('显示loading')
    //     return () => {
    //         console.log('隐藏loading')
    //     }
    // }
})
